import { findFleets } from '@src/main/modules/ibdp/application/find-fleets.usecase';
import { IbdpRepository } from '@src/main/modules/ibdp/domain/ibdp.repository';
import { createIbdpHttpRepository } from '@src/main/modules/ibdp/infrastructure/IbdpHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useFleets = (fleet: string, subFleet: string) => {
  const { user } = useAuth();
  const [repository, setRepository] = useState<IbdpRepository | null>(null);

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);

  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  useEffect(() => {
    if (user?.token) {
      const repo = createIbdpHttpRepository(tokenProvider);
      setRepository(repo);
    } else {
      setRepository(null);
    }
  }, [user?.token, tokenProvider]);

  const queryResult = useQuery({
    queryKey: ['fleet', fleet, subFleet],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await findFleets(repository, fleet, subFleet);
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });

  return queryResult;
};
